import React, { useState, useRef, useEffect } from 'react';
import axios from 'axios';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Loader from '../../components/utils/Loader';
import useFetch from '../../hooks/useFetch';
import { BrowserMultiFormatReader } from '@zxing/library';
import QRCode from 'react-qr-code';
import MainLayout from '../../layouts/MainLayout';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {  faComment, faEdit, faCamera, faQrcode, faList, faListUl } from '@fortawesome/free-solid-svg-icons';
import './BeSure.css';


const BeSureCheckProduct = () => {
  const authState = useSelector(state => state.authReducer);
  const [fetchData, { loading }] = useFetch();
  const [productCode, setProductCode] = useState('');
  const [productDetails, setProductDetails] = useState(null);
  const [error, setError] = useState('');
  const [belongsToOther, setBelongsToOther] = useState(false);
  const [belongsToMe, setBelongsToMe] = useState(false);
  const [scannedProductCode, setScannedProductCode] = useState('');
  const [scanResult, setScanResult] = useState('');
  const [scanning, setScanning] = useState(false);
  const videoRef = useRef(null);
  const [qrCodeData, setQrCodeData] = useState('');

  const [userDetails, setUserDetails] = useState({
    userId: '',
    userName: '',
    city: '',
    pin: '',
  });

  const [newProductDetails, setNewProductDetails] = useState({
    productName: '',
    shopName: '',
    shopAddress: '',
    city: '',
    pin: '',
    datePurchase: '',
    comment: '',
  });
  const [message, setMessage] = useState('');
  const navigate = useNavigate();

  const handleInputChange = (e) => {
    setProductCode(e.target.value);
  };

  const handleUserDetailsChange = (e) => {
    const { name, value } = e.target;
    setUserDetails({ ...userDetails, [name]: value });
  };

  const handleNewProductDetailsChange = (e) => {
    const { name, value } = e.target;
    setNewProductDetails({ ...newProductDetails, [name]: value });
  };

  const handleCheckProduct = async (e) => {
    e.preventDefault();
    
    if (!productCode.trim()) {
      setError('Product code cannot be blank.');
      return;
    }
    
    try {
      const config = { 
        url: `/besurebank/getproduct`, 
        method: "post", 
        headers: { Authorization: authState.token }, 
        data: { productCode }
      };
  
      const response = await fetchData(config, { showSuccessToast: false });
      // console.log("Search response ", response);
  
      if (!response.status) {
        setError(response.message || "Error fetching product data.");
        setProductDetails(null);
        setBelongsToOther(false);
        setBelongsToMe(false);
      } else {
        const { entry } = response;
        setProductDetails(entry);
  
        if (entry.scannedName) {
          if (entry.scannedName === authState.user.name) {
            setError("As per beSure Database, this Product already belongs to You");
            setBelongsToMe(true);
            setBelongsToOther(false);
          } else {
            setError("As per beSure database, this Product belongs to Somebody else");
            setBelongsToOther(true);
            setBelongsToMe(false);
          }
        } else {
          setError('');
          setBelongsToOther(false);
          setBelongsToMe(false);
        }
        
        setMessage('');
      }
    } catch (error) {
      console.error("Error fetching beSure data:", error);
      setError("Error fetching beSure data");
      setBelongsToOther(false);
      setBelongsToMe(false);
    }
  };

  const handleUpdateBesureBank = (e) => {
    e.preventDefault();
    // Add your logic to update the product in beSureBank here
  };

  const handleAddBesureFake = (e) => {
    e.preventDefault();
    // Add your logic to add the product to beSureFake here
  };

  const handleBackToHome = () => {
    navigate('/besure-home');
  };

  const handleScan = (result) => {
    if (result) {
      setScanResult(result);
      setScanning(false);
    }
  };

  const handleError = (error) => {
    console.error(error);
    setScanning(false);
  };

  // const startScanning = () => {
  //   const codeReader = new BrowserMultiFormatReader();
  //   codeReader
  //     .decodeFromVideoDevice(null, videoRef.current, (result, error) => {
  //       if (result) {
  //         handleScan(result.text);
  //       }
  //       if (error) {
  //         handleError(error);
  //       }
  //     });
  // };

  // useEffect(() => {
  //   let codeReader;

  //   const startScanning = async () => {
  //     if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
  //       codeReader = new BrowserMultiFormatReader();
  //       try {
  //         const stream = await navigator.mediaDevices.getUserMedia({ video: { facingMode: 'environment' } });
  //         videoRef.current.srcObject = stream;
  //         codeReader.decodeFromVideoDevice(null, videoRef.current, (result, err) => {
  //           if (result) {
  //             setQrCodeData(result.text);
  //             setScanning(false);
  //             if (videoRef.current.srcObject) {
  //               const tracks = videoRef.current.srcObject.getTracks();
  //               tracks.forEach(track => track.stop());
  //             }
  //           }
  //           if (err && !(err instanceof NotFoundException)) {
  //             console.error(err);
  //           }
  //         });
  //       } catch (error) {
  //         console.error('Error accessing media devices.', error);
  //         setScanning(false);
  //       }
  //     } else {
  //       console.error('getUserMedia not supported by this browser.');
  //       setScanning(false);
  //     }
  //   };

  //   if (scanning) {
  //     startScanning();
  //   }

  //   return () => {
  //     if (codeReader) {
  //       codeReader.reset();
  //     }
  //     if (videoRef.current && videoRef.current.srcObject) {
  //       const tracks = videoRef.current.srcObject.getTracks();
  //       tracks.forEach(track => track.stop());
  //     }
  //   };
  // }, [scanning]);

  useEffect(() => {
    let codeReader;

    const startScanning = async () => {
      if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
        codeReader = new BrowserMultiFormatReader();
        try {
          const stream = await navigator.mediaDevices.getUserMedia({ video: { facingMode: 'environment' } });
          videoRef.current.srcObject = stream;
          codeReader.decodeFromVideoDevice(null, videoRef.current, (result, err) => {
            if (result) {
              setQrCodeData(result.text);
              setScanning(false);
              if (videoRef.current.srcObject) {
                const tracks = videoRef.current.srcObject.getTracks();
                tracks.forEach(track => track.stop());
              }
            }
            if (err && !(err instanceof NotFoundException)) {
              console.error(err);
            }
          });
        } catch (error) {
          console.error('Error accessing media devices.', error);
          setScanning(false);
        }
      } else {
        console.error('getUserMedia not supported by this browser.');
        setScanning(false);
      }
    };

    if (scanning) {
      startScanning();
    }

    return () => {
      if (codeReader) {
        codeReader.reset();
      }
      if (videoRef.current && videoRef.current.srcObject) {
        const tracks = videoRef.current.srcObject.getTracks();
        tracks.forEach(track => track.stop());
      }
    };
  }, [scanning]);


  return (
    <MainLayout>
      <div>
        <h2 className='text-lg mx-2 border-b border-b-gray-300 text-white'>BeSure - Check Product</h2>
      </div>
      <div className="m-auto my-2 p-2 border-2 shadow-md rounded-md md:w-7/12 w-full">
        <form onSubmit={handleCheckProduct}>
          <div className='p-6 border-2 shadow-md rounded-md mb-4'>
            <div className='flex flex-col items-center mt-8 px-4'>
              <label className='text-2xl md:text-3xl font-medium text-orange-300 text-center'>
                हमेशा beSure@Think5Whys से पूछो
              </label>
            </div>
            <div className='mt-8 mb-4 flex flex-col items-center justify-center'>
              <div className='flex flex-row'>
                <i className="fas fa-barcode text-yellow-200 text-5xl mb-2 ml-2 mr-2"></i>
                <i className="fas fa-keyboard text-white text-5xl mb-2 ml-2 mr-2"></i>
                <i className="fas fa-qrcode text-orange-300 text-5xl mb-2 ml-2 mr-2" ></i>
              </div>
              <div className='flex flex-col items-center mr-4'>
                <label className='text-lg font-medium text-white'>Product Code:</label>
              </div>
              <input
                type="text"
                name="productCode"
                value={productCode}
                onChange={handleInputChange}
                className='w-full max-w-md p-2 bg-gray-700 border border-gray-600 rounded-md text-gray-300 text-center'
                />
            </div>
            {error && !belongsToMe && (
              <div className='text-red-300 text-center text-lg mb-4'>
                <i class="fas fa-exclamation-triangle text-yellow-200 text-5xl"></i>
                <p>{error}</p>
              </div>
            )}
            <div className='flex flex-row justify-center mb-4'>
              <button className="w-50" type="submit" onClick={handleCheckProduct}>
                  Check My Product
              </button>
              <button className="ml-4 w-50" onClick={handleBackToHome}>Back to Home</button>
            </div>
          
            <div className='flex flex-col justify-center'>
              <div className='flex flex-row justify-center'>
                <button
                  className='btn btn-scan w-full'
                  onClick={() => setScanning(true)}
                  disabled={scanning}
                >
                  <FontAwesomeIcon icon={faCamera} /> Scan QR Code
                </button>
                {/* <button
                  className='btn btn-generate ml-2 w-full'
                  onClick={() => setProductCode('')}
                >
                  <FontAwesomeIcon icon={faQrcode} /> Generate QR Code
                </button> */}
              </div>
              {scanning ? (
                <div className='scanner'>
                  <video ref={videoRef} style={{ width: '100%' }} autoPlay />
                </div>
              ) : (
                <div className='flex flex-row justify-center '>
                  <p className='text-lg text-yellow-200 flex items-center'>QR Code Scanning Not Supported By Your Browser</p>
                </div>
              )}

              {qrCodeData && (
                <div className='qr-code-data'>
                  <h3 className='text-lg font-medium text-white'>Scanned QR Code Data:</h3>
                  <p className='text-gray-300'>{qrCodeData}</p>
                </div>
              )}
              {/* <div className='flex flex-col justify-center'>
                <h3 className='text-lg font-medium text-white'>Generate QR Code:</h3>
                <QRCode value={productCode} />
              </div> */}
            </div>
          </div>
        </form>
        {productDetails && !belongsToOther && (
          <div className='p-6 bg-gray-800 text-white rounded-md shadow-md'>
          <div className='flex items-center justify-center mb-4'>
            <h2 className='text-2xl font-bold text-blue-400'>Product Details</h2>
          </div>
          <div className='flex flex-col items-center mt-8 px-4'>
              <i className="fas fa-check-circle text-green-400 text-5xl"></i>
              <label className='text-2xl md:text-3xl font-medium text-orange-300 text-center'>
                  beSure@Think5Whys Authenticated
              </label>
            </div>
          {belongsToMe && (
            <div className='flex items-center flex-col justify-center mb-4'>
              <i className="fas fa-thumbs-up text-green-500"></i>
              <h2 className='text-2xl font-bold text-green-400'>{authState.user.name}</h2>
          </div>
          )}
        
          <div className='mb-6'>
            <div className='grid grid-cols-2 gap-4'>
              <div>
                <p className='text-lg font-semibold'>Product Name:</p>
                <p className='text-gray-300'>{productDetails.productName}</p>
              </div>
              <div>
                <p className='text-lg font-semibold'>Product Brief:</p>
                <p className='text-gray-300'>{productDetails.productBrief}</p>
              </div>
              <div>
                <p className='text-lg font-semibold'>Brand Name:</p>
                <p className='text-gray-300'>{productDetails.productBrand}</p>
              </div>
              <div>
                <p className='text-lg font-semibold'>Manufacturing Date:</p>
                <p className='text-gray-300'>{new Date(productDetails.mfgDate).toLocaleDateString()}</p>
              </div>
              <div>
                <p className='text-lg font-semibold'>Expiry Date:</p>
                <p className='text-gray-300'>{new Date(productDetails.expDate).toLocaleDateString()}</p>
              </div>
              <div>
                <p className='text-lg font-semibold'>Batch Number:</p>
                <p className='text-gray-300'>{productDetails.batchNumber}</p>
              </div>
            </div>
          </div>
        
          {/* <form onSubmit={handleUpdateBesureBank} className='space-y-4'>
            <div>
              <label className='block text-sm font-medium text-gray-400'>User ID:</label>
              <input type="text" name="userId" value={userDetails.userId} onChange={handleUserDetailsChange} className='mt-1 block w-full p-2 bg-gray-700 border border-gray-600 rounded-md text-gray-300' />
            </div>
            <div>
              <label className='block text-sm font-medium text-gray-400'>User Name:</label>
              <input type="text" name="userName" value={userDetails.userName} onChange={handleUserDetailsChange} className='mt-1 block w-full p-2 bg-gray-700 border border-gray-600 rounded-md text-gray-300' />
            </div>
            <div>
              <label className='block text-sm font-medium text-gray-400'>City:</label>
              <input type="text" name="city" value={userDetails.city} onChange={handleUserDetailsChange} className='mt-1 block w-full p-2 bg-gray-700 border border-gray-600 rounded-md text-gray-300' />
            </div>
            <div>
              <label className='block text-sm font-medium text-gray-400'>PIN:</label>
              <input type="text" name="pin" value={userDetails.pin} onChange={handleUserDetailsChange} className='mt-1 block w-full p-2 bg-gray-700 border border-gray-600 rounded-md text-gray-300' />
            </div>
            <button type="submit" className='w-full bg-blue-500 hover:bg-blue-600 text-white font-bold py-2 px-4 rounded-md'>Update Product</button>
          </form> */}
        </div>
        )}
        {message && !productDetails && (
          <div className='text-sm text-black p-6 border-2 shadow-md rounded-md'>
            <p className='flex justify-center text-lg text-red-300 mb-4'>{message}</p>
            <form onSubmit={handleAddBesureFake} className='space-y-4'>
              <div className='flex items-center'>
                <label className='w-1/4 pr-4'>Product Name:</label>
                <input
                  type='text'
                  name='productName'
                  value={newProductDetails.productName}
                  onChange={handleNewProductDetailsChange}
                  style={{ width: "400px" }}
                  className='p-2 border border-gray-700 rounded'
                  required
                />
              </div>
              <div className='flex items-center'>
                <label className='w-1/4  pr-4'>Shop Name:</label>
                <input
                  type='text'
                  name='shopName'
                  value={newProductDetails.shopName}
                  onChange={handleNewProductDetailsChange}
                  style={{ width: "400px" }}
                  className='p-2 border border-gray-700 rounded'
                  required
                />
              </div>
              <div className='flex items-center'>
                <label className='w-1/4  pr-4'>Shop Address:</label>
                <textarea
                  type='text'
                  name='shopAddress'
                  value={newProductDetails.shopAddress}
                  onChange={handleNewProductDetailsChange}
                  className='p-2 border border-gray-700 rounded'
                  maxLength="2000"
                  style={{
                    border: '1px solid #ccc',
                    padding: '2px',
                    backgroundColor: '#f0f0f0', 
                    color: '#000000',
                    maxWidth: '650px', 
                    maxHeight: '150px' 
                  }}
                  required
                />
              </div>
              <div className='flex items-center'>
                <label className='w-1/4  pr-4'>City:</label>
                <input
                  type='text'
                  name='city'
                  value={newProductDetails.city}
                  onChange={handleNewProductDetailsChange}
                  style={{ width: "200px" }}
                  className='p-2 border border-gray-700 rounded'
                  required
                />
              </div>
              <div className='flex items-center'>
                <label className='w-1/4  pr-4'>PIN:</label>
                <input
                  type='text'
                  name='pin'
                  value={newProductDetails.pin}
                  onChange={handleNewProductDetailsChange}
                  style={{ width: "150px" }}
                  className='p-2 border border-gray-700 rounded'
                  required
                />
              </div>
              <div className='flex items-center'>
                <label className='w-1/4  pr-4'>Date of Purchase:</label>
                <input
                  type='date'
                  name='datePurchase'
                  value={newProductDetails.datePurchase}
                  onChange={handleNewProductDetailsChange}
                  style={{ width: "100px" }}
                  className='p-2 border border-gray-700 rounded'
                  required
                />
              </div>
              <div className='flex items-center'>
                <label className='w-1/4  pr-4'>Comment:</label>
                <textarea
                  type='text'
                  name='comment'
                  value={newProductDetails.comment}
                  onChange={handleNewProductDetailsChange}
                  maxLength="2000"
                  style={{
                    border: '1px solid #ccc',
                    padding: '2px',
                    backgroundColor: '#f0f0f0', 
                    color: '#000000',
                    maxWidth: '650px', 
                    maxHeight: '150px' 
                  }}
                  className='p-2 border border-gray-700 rounded'
                  required
                />
              </div>
              <div className='flex items-center'>
                <label className='w-1/4  pr-4'>User ID:</label>
                <input
                  type='text'
                  name='userId'
                  value={userDetails.userId}
                  onChange={handleUserDetailsChange}
                  style={{ width: "150px" }}
                  className='p-2 border border-gray-700 rounded'
                  required
                />
              </div>
              <div className='flex items-center'>
                <label className='w-1/4  pr-4'>User Name:</label>
                <input
                  type='text'
                  name='userName'
                  value={userDetails.userName}
                  onChange={handleUserDetailsChange}
                  style={{ width: "200px" }}
                  className='p-2 border border-gray-700 rounded'
                  required
                />
              </div>
              <div className='flex items-center'>
                <label className='w-1/4  pr-4'>User City:</label>
                <input
                  type='text'
                  name='city'
                  value={userDetails.city}
                  onChange={handleUserDetailsChange}
                  style={{ width: "200px" }}
                  className='p-2 border border-gray-700 rounded'
                  required
                />
              </div>
              <div className='flex items-center'>
                <label className='w-1/4  pr-4'>User PIN:</label>
                <input
                  type='text'
                  name='pin'
                  value={userDetails.pin}
                  onChange={handleUserDetailsChange}
                  style={{ width: "150px" }}
                  className='p-2 border border-gray-700 rounded'
                  required
                />
              </div>
              <div className='flex justify-center'>
                <button
                  type='submit'
                  className='mt-4 px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700'
                >
                  Add to beSureFake
                </button>
              </div>
          </form>
        </div>
        )}
        {/* <button onClick={handleBackToHome}>Back to Home</button> */}
      </div>
    </MainLayout>
  );
};

export default BeSureCheckProduct;
